module.exports = __webpack_public_path__ + "img/slider-people-1.1f07a244.png";